import React, { useEffect, useState } from 'react';
import ProductOpinion from '../product-opinion-list/components/product-opinion/product-opinion';
import { OpinionsItemsInterface } from 'interfaces/opinions.interface';
import Link from 'atomic/link';
import opineoBlue from 'assets/images/opineo_blue.svg';
import ProductOpinionFilters from './components/product-opinion-filters/product-opinion-filters';
import { offerOpinionSort } from 'modules/product/views/components/product-opinion-section/components/product-opinion-list/helpers/offer-opinion-sort';

import './product-opinion-list.scss';

interface OpinionListProps {
    url: string;
    count: number;
    items: OpinionsItemsInterface[];
}

const ProductOpinionList: React.FC<OpinionListProps> = ({ url, count, items }) => {
    const [params, setParams] = useState<{ rating: string; sort: string; }>({
        rating: '0',
        sort: ''
    });

    const [opinions, setOpinions] = useState(items);

    const onFilter = (rating: string): void => {
        setParams(prevState => ({
            ...prevState,
            rating
        }));
    };

    const onSort = (sort: string): void => {
        setParams(prevState => ({
            ...prevState,
            sort
        }));
    };

    useEffect(() => {
        setOpinions(items.filter(opinion => params.rating === '0' || opinion.rating === Number(params.rating)).sort(offerOpinionSort(params.sort)));
    }, [params, items]);

    return (
        <>
            { items.length > 0 && (
                <ProductOpinionFilters onFilter={onFilter} onSort={onSort} params={params} />
            )}
            <ul className="opinion-list">
                {
                    opinions.map(({ rating, author, content, timestamp, likes, pros, cons }, index) => (
                        <li key={index} className="opinion-list__item">
                            <ProductOpinion
                                rating={rating}
                                author={author}
                                content={content}
                                timestamp={timestamp}
                                likes={likes}
                                pros={pros}
                                cons={cons}
                            />
                        </li>
                    ))
                }
                {(opinions.length === 0 && Number(params.rating) > 0 && count <= 10) && (
                    <li className="opinion-list__item opinion-list__item--no-results">
                        Brak opinii dla wybranych filtrów
                    </li>
                )}
                {
                    count > items.length && (
                        <li className="opinion-list__item opinion-list__item--link">
                            <Link href={url}>
                                <span className="opinion-list__item--link__text">
                                    Przeczytaj
                                    {String((opinions.length === 0 && Number(params.rating) > 0 && count > 10) ? ' ' : ' pozostałe ')}
                                    opinie na
                                </span>
                                <img
                                    src={opineoBlue}
                                    height={26}
                                    width={120}
                                    loading="lazy"
                                    alt="Opineo.pl"
                                />
                            </Link>
                        </li>
                    )
                }
            </ul>
        </>
    );
};

export default ProductOpinionList;
